declare namespace $ {

	type $mol_view__sub_bog_ui_sidebar_item_1 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $bog_ui_sidebar_item extends $mol_button_minor {
		Label( ): $mol_view
		Icon( ): $mol_icon
		label( ): string
		active( ): boolean
		collapsed( next?: boolean ): boolean
		sub( ): readonly(any)[]
		attr( ): ({ 
			'bog_ui_sidebar_item_active': ReturnType< $bog_ui_sidebar_item['active'] >,
			'bog_ui_sidebar_item_collapsed': ReturnType< $bog_ui_sidebar_item['collapsed'] >,
		})  & ReturnType< $mol_button_minor['attr'] >
	}
	
}

//# sourceMappingURL=item.view.tree.d.ts.map